import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useCreateClearerUser from '../../../hooks/user/useClearerUser';
import useListWarehouses from '../../../hooks/warehouse/useListWarehouse';
import {
  ClearerUserDataType,
  ClearerUserInitialValues,
  ClearerUserSchema,
  IClearerUserRequest,
} from '../../../models/user/clearerUser.model';

const CreateClearerModal = () => {
  const { listOfWarehouses } = useListWarehouses();
  const { createClearerUser, loading } = useCreateClearerUser();

  const onSubmit = (values: ClearerUserDataType, actions: any) => {
    const data: IClearerUserRequest = {
      ...values,
      phoneNumber: '234' + values.phoneNumber.slice(1),
      warehouseId: listOfWarehouses.filter(
        (data: any) => data.name === values.warehouseId
      )[0].id,
    };

    createClearerUser(data);

    // if (resetInputFields) {
    actions.resetForm(ClearerUserInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Clearer'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={ClearerUserInitialValues}
          schema={ClearerUserSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="First Name"
            name="firstName"
            type="text"
            placeholder="Enter First Name"
            className="full"
          />
          <TextInputField
            label="Last Name"
            name="lastName"
            type="text"
            placeholder="Enter Last Name"
            className="full"
          />
          <TextInputField
            label="User Name"
            name="userName"
            type="text"
            placeholder="Enter User Name"
            className="full"
          />
          <TextInputField
            label="email"
            name="email"
            type="email"
            placeholder="Enter Email"
            className="full"
          />
          <TextInputField
            label="Phone Number"
            name="phoneNumber"
            type="text"
            placeholder="Enter Phone No"
            className="full"
          />
          <SelectField label="Warehouse" name="warehouseId">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Warehouse'}
            </option>
            {listOfWarehouses &&
              listOfWarehouses.map((data: any, index: number) => (
                <option key={index}>{data.name}</option>
              ))}
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Clearer
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};
export default CreateClearerModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
